import { createContext } from "react";

export const ClientesContext = createContext()
export const ClientesFormContext = createContext()
export const ClientesReportContext = createContext()